module.exports = __webpack_public_path__ + "img/velocity.f5357f94.png";